<template>
  <v-flex xs6 class="mr-1">
    <v-card class="mb-2">
      <v-card-title class="mb-2">
        <v-avatar class="secondary">
          <v-icon dark>fas fa-pound-sign</v-icon>
        </v-avatar>
        <div class="ml-3">
          <h4 class="headline">Fixed Fee</h4>
          <span class="body-2">Fees can be manually adjusted when setting funding released on an enquiry</span>
        </div>
      </v-card-title>
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 sm3>
                <v-text-field label="Fixed Fee" v-model="fixedFee" required></v-text-field>
              </v-flex>
              <v-flex xs6 sm3 class="text-md-right">
                <v-btn color="accent" @click="updateFixedFee()">Update</v-btn>
                <v-btn color="accent" @click="deleteFixedFee()">Remove</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'fixedFee',
  data: () => ({
    fixedFee: 0.0
  }),
  computed: {
    ...mapGetters(['SelectedFunder'])
  },
  methods: {
    ...mapActions(['updateFunder']),
    updateFixedFee() {
      const updates = { fixed_fee: this.fixedFee };
      this.updateFunder({ id: this.SelectedFunder.id, updates });
    },
    deleteFixedFee() {
      const updates = { fixed_fee: 0.0 };
      this.updateFunder({ id: this.SelectedFunder.id, updates });
    }
  },
  mounted() {
    this.fixedFee = this.SelectedFunder.fixed_fee;
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .header {
    font-weight: 700;
    font-size: 0.9rem;
    color: rgba(0, 0, 0, 0.54);
    border-bottom: 1px solid #ddd;
  }
}
</style>
